/* eslint-disable */
import {
    ERROR_ACTION, CANDIDATE_LIST_FOR_CHECK_ELIGIBILTY, SET_PROFILE_CREATION_LOOKUPS,
    SET_SHOW_ACTIVE_TAB_CANDIDATE_DETAILS, SET_APPLICATION_ELIGIBILITY_INFO, ACTIVE_ADVERTISEMENT_LIST,
    SET_ADVERTISEMENT_DETAILS_FOR_CANDIDATE, SET_PROFILE_INFO_DISPLAY, SET_QUALIFICATION_TYPES, SET_ACTIVE_ADVERTISEMENT_LIST_PAGE_NO_COUNTER, GET_ALL_ADVERTISEMENT_LIST, GET_TYPE_OF_ARTICLES,
    SET_APPLICATION_RE_CHECK_ELIGIBILITY_INFO, SET_ELIGIBILITY_BUTTON_DISABLE, SET_APPLICATION_POST_PREF_LIST_RE_CHECK_ELIGIBILITY, SET_APPLICATION_DETAILS_FOR_CANDIDATE_MANAGEMENT, GET_NAME_OF_INDEXING_BODIES,
    GET_SINGLE_ADVT_DETAILS,CANDIDATE_REPORTS,SET_LIST_REPORT,ADVERTISEMENT_REPORT_DOWNLOAD,CANDIDATE_PAYMENT_LIST
} from "../../common/constants/ActionTypes";

const initialState = {
    errorMessage: "",
    showActiveTabCandidateDetails: false,
    activeAdvertisementList: [],
    candidateList: [],
    selectedProfile: [],
    advertisementId: null,
    profileId: null,
    advertisementDetailsForCandidate: [],
    eligibilityResultList: null,
    reCheckEligibilityResultList: null,
    applicationPostPrefListForReCheckEligibility: null,
    applicationFee: null,
    profileInfo: null,
    profileCreationAllLookupData: [],
    statesList: [],
    qualificationTypes: [],
    eligiblityButtonDisabled: false,
    applicationDetails: {},
    getAllAdvertisementList: [],
    getAllAdvertisementPageNoCounter: 0,
    nameOfIndexingBodiesList: [],
    getPublicationArticleTypeList: [],
    singleAdvtDetails: {},
    candidatePaymentList:{}
}

export default function candidateDataManagementReducer(state = initialState, action) {
    switch (action.type) {
        case ERROR_ACTION:
            return {
                ...state,
                errorMessage: action.payload
            }
        case CANDIDATE_LIST_FOR_CHECK_ELIGIBILTY:
            return {
                ...state,
                candidateList: action.payload
            }
        case ACTIVE_ADVERTISEMENT_LIST:
            return {
                ...state,
                activeAdvertisementList: action.payload
            }
        case SET_SHOW_ACTIVE_TAB_CANDIDATE_DETAILS:
            return {
                ...state,
                showActiveTabCandidateDetails: action.payload,
                advertisementId: action.advertisementId,
                profileId: action.profileId,
                selectedProfile: action.selectedProfile
            }
        case SET_ADVERTISEMENT_DETAILS_FOR_CANDIDATE:
            return {
                ...state,
                advertisementDetailsForCandidate: action.payload
            }
        case SET_APPLICATION_ELIGIBILITY_INFO:
            return {
                ...state,
                eligibilityResultList: action.payload.eligibilityResultDtoList,
                applicationFee: action.payload.applicationFee,
            }
        case SET_APPLICATION_RE_CHECK_ELIGIBILITY_INFO:
            return {
                ...state,
                reCheckEligibilityResultList: action.payload,
            }
        case SET_APPLICATION_POST_PREF_LIST_RE_CHECK_ELIGIBILITY:
            return {
                ...state,
                applicationPostPrefListForReCheckEligibility: action.payload
            }
        case SET_PROFILE_INFO_DISPLAY:
            return {
                ...state,
                profileInfo: action.payload
            }
        case SET_PROFILE_CREATION_LOOKUPS:
            return {
                ...state,
                profileCreationAllLookupData: action.payload
            }
        case SET_QUALIFICATION_TYPES:
            return {
                ...state,
                qualificationTypes: action.payload
            }
        case SET_ELIGIBILITY_BUTTON_DISABLE:
            return {
                ...state,
                eligiblityButtonDisabled: action.payload
            }
        case SET_APPLICATION_DETAILS_FOR_CANDIDATE_MANAGEMENT:
            return {
                ...state,
                applicationDetails: action.payload
            }
        case GET_ALL_ADVERTISEMENT_LIST:
            return {
                ...state,
                getAllAdvertisementList: action.payload
            }
        case SET_ACTIVE_ADVERTISEMENT_LIST_PAGE_NO_COUNTER:
            return {
                ...state,
                getAllAdvertisementPageNoCounter: action.payload
            }
        case GET_NAME_OF_INDEXING_BODIES:
            return {
                ...state,
                nameOfIndexingBodiesList: action.payload,
            }
        case GET_TYPE_OF_ARTICLES:
            return {
                ...state,
                getPublicationArticleTypeList: action.payload,
            }
        case GET_SINGLE_ADVT_DETAILS:
            return {
                ...state,
                singleAdvtDetails: action.payload,
            }

             case CANDIDATE_REPORTS:
            return {
                ...state,
                candidateListReport: action.payload
            }

             case SET_LIST_REPORT:
            return {
                ...state,
                reportList: action.payload
            }

        case ADVERTISEMENT_REPORT_DOWNLOAD:
            return {
                ...state,
                advertisementReportDownload: action.payload
            }
        case CANDIDATE_PAYMENT_LIST:
            return {
                ...state,
                candidatePaymentList: action.payload
            }
        default:
            return state;
    }
}